
























import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref,
} from "vue-property-decorator";

import api from "@/api";
import { ManualConfirmOrderPaySuccessInput} from "@/api/appService";
import { ElForm } from "element-ui/types/form";

@Component({
  name: "EditAnchor",
})
export default class EditAnchor extends Vue {
  @Ref() readonly dataForm!: ElForm;

  @Prop({ required: true })
  dataId!: number;

  defaultData: ManualConfirmOrderPaySuccessInput = {
    orderId: 0,
    transactionId: ''
  };

  show = false;
  form: ManualConfirmOrderPaySuccessInput = { ...this.defaultData };

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      const loading = this.$loading({
        target: ".el-dialog",
      });

      if (this.dataId) {
        this.form.orderId=this.dataId;
        setTimeout(() => {
          loading.close();
        }, 200);
      } else {
        this.form = { ...this.defaultData };
        //
        setTimeout(() => {
          loading.close();
        }, 200);
      }
    } else {
      this.form = { ...this.defaultData };
    }

    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  async save() {
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await api.studentBidOrder.manualConfirmOrderPaySuccess({body: this.form});
        this.show = false;
        this.$message.success("订单完成");
        this.$emit("onSave");
      }
    });
  }

  cancel() {
    this.show = false;
  }

  linkRule = {
    transactionId: [
      {
        required: true,
        message: "请输入订单流水号",
        trigger: "change",
      },
    ],
  };
}
